<template>
  <div class="edit-webpage flex-grow-1 d-flex flex-column">
    <div v-if="isLoading" class="mt-4">
      <Spinner />
    </div>
    <a-form v-show="!isLoading" id="edit-webpage-form" :form="editWebpageForm" class="flex-grow-1 d-flex flex-column edit-form" @submit="onSubmit">
      <div class="a-header">
        <span class="a-header--title slide-down-enter-active">
          Edit Webpage Configuration
        </span>
        <div>
          <a-button size="default" class="slide-down-enter-active a-header--button success-btn ml-2" @click="rebaselineWebpage">
            <img class="mr-2" src="@assets/icon/OffHover.svg">
            Re-Baseline
          </a-button>
          <a-button size="default" class="slide-down-enter-active a-header--button success-btn" @click="manualVerifyWebpage">
            <a-icon theme="filled" type="check-circle" /> Verify Webpage
          </a-button>
        </div>
      </div>
      <div class="a-body flex-grow-1 p-20-px">
        <transition-group name="slide-up">
          <template v-if="true">
            <div key="info" class="info">
              <a-row :gutter="20">
                <a-col :span="9">
                  <a-form-item label="Webpage Name">
                    <a-input v-decorator="['webPageName']" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="Webpage URL">
                    <a-input v-decorator="['webPageUrl']" disabled />
                  </a-form-item>
                </a-col>
                <a-col :span="3">
                  <a-form-item label="Port">
                    <a-input v-decorator="[`webPagePort`]" disabled />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            <div key="tabs" class="tabs">
              <a-tabs type="card" :activeKey="activeTabKey" @change="onTabChange">
                <a-tab-pane
                  :key="ActivatedTabKeys.GeneralSettings"
                  :forceRender="true"
                  tab="General Settings"
                >
                  <a-row :gutter="20">
                    <a-col v-show="webpage.is_part_of_domain" :span="8">
                      <a-form-item label="Monitoring Type">
                        {{ webpage.monitoring_type }} (Domain Monitoring)
                      </a-form-item>
                    </a-col>
                    <a-col v-show="!webpage.is_part_of_domain" :span="8">
                      <a-form-item label="Plan type">
                        <a-select v-decorator="['planType']" size="large">
                          <template v-for="(valuePlanType, keyPlanType) in planTypes">
                            <a-select-option v-if="valuePlanType.limit - valuePlanType.count" :key="keyPlanType" :value="keyPlanType">
                              {{ keyPlanType | lowercase | capitalize }} -
                              {{ valuePlanType.limit - valuePlanType.count }}
                              URLs left
                            </a-select-option>
                          </template>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="User Agent">
                        <a-select v-decorator="[`userAgent`]" size="large">
                          <a-select-option v-for="userAgent in userAgents" :key="userAgent.id" :value="userAgent.id">
                            {{ userAgent.alias }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="Downtime Alert">
                        <a-select v-decorator="[`downTimeAlert`]" size="large">
                          <a-select-option v-for="downtime in downtimeAlerts" :key="downtime.id" :value="downtime.id">
                            {{ downtime.name }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col v-show="webpage.is_part_of_domain" :span="8">
                      <a-form-item label="Polling Interval">
                        <span v-if="webpage.monitoring_type=='Variable'">
                          Variable (Domain Monitoring)
                        </span>
                        <span v-else>
                          {{ webpage.polling_interval }} minutes
                        </span>
                      </a-form-item>
                    </a-col>
                    <a-col v-show="!webpage.is_part_of_domain" :span="8">
                      <a-form-item label="Polling Interval">
                        <a-select v-decorator="['pollingInterval']" size="large">
                          <a-select-option v-for="(pulling, keyPolling) in pullingIntervals" :key="+keyPolling" :value="+keyPolling">
                            {{ pulling | timeText }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="Policy">
                        <a-input v-decorator="['policy']" disabled />
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label=" " class="hidden-label">
                        <div class="d-flex flex-wrap align-items-center" style="gap: 12px">
                          <a-checkbox v-decorator="['isContinuousMonitor', { valuePropName: 'checked' }]">
                            Continuous Monitoring
                            <a-tooltip placement="top">
                              <template slot="title">
                                <span class="fs-10">
                                  This option was previously
                                  <b>Enable Alerts for Subsequent Changes</b>. It will monitor and send alerts for further changes from the previous detected change.
                                </span>
                              </template>
                              <a-icon class="explain" type="info-circle" theme="filled" />
                            </a-tooltip>
                          </a-checkbox>
                          <a-button size="large" @click="openRenderingConfig">
                            <a-icon type="setting" /> Rendering Config
                          </a-button>
                        </div>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="20">
                    <a-col :span="8">
                      <a-form-item label="Users to notify">
                        <template v-if="isContactGroupsLoaded && contactGroups.length > 0">
                          <template v-if="displayedContacts.length === 5">
                            <a-alert type="info" show-icon>
                              <template slot="message">
                                {{ displayedContacts.toString() }}... <a class="ml-3" @click="showContactsModal">View all users</a>
                              </template>
                            </a-alert>
                          </template>
                          <template v-else-if="displayedContacts.length === 0">
                            <a-alert show-icon type="warning">
                              <template slot="message">
                                The contact groups assigned to the webpage are empty. Please add contacts to those groups <router-link to="/contact/list">here</router-link>
                              </template>
                            </a-alert>
                          </template>
                          <template v-else>
                            <a-alert type="info" show-icon>
                              <template slot="message">
                                {{ displayedContacts.toString() }} <a class="ml-3" @click="showContactsModal">View all users</a>
                              </template>
                            </a-alert>
                          </template>
                        </template>
                        <template v-if="isContactGroupsLoaded && contactGroups.length == 0">
                          <a-alert show-icon type="warning">
                            <template slot="message">
                              There are no contact groups assigned to this webpage. Please assign a contact group <router-link to="/notification/list">here</router-link>
                            </template>
                          </a-alert>
                        </template>
                        <template v-if="!isContactGroupsLoaded">
                          <a-button loading disabled>
                            Loading...
                          </a-button>
                        </template>
                      </a-form-item>
                    </a-col>
                    <a-modal
                      title="Contacts"
                      :bodyStyle="{ height: '65vh', overflowY: 'auto'}"
                      width="65vw"
                      cancelText="Close"
                      :okButtonProps="{
                        style: {
                          display: 'none'
                        },
                      }"
                      :closable="false"
                      :visible="isModalVisible"
                      @cancel="handleContactsModalCancel"
                    >
                      <PaginationTable
                        :clientPaging="false"
                        :columns="ContactGroupColumns"
                        :dataSource="contactGroups"
                      >
                        <template slot="index" slot-scope="{ record }">
                          <p class="text-truncate">
                            {{ record.index }}
                          </p>
                        </template>
                        <template slot="contact_group" slot-scope="{ record }">
                          <p class="text-truncate">
                            {{ record.description }}
                          </p>
                        </template>
                        <template slot="contacts" slot-scope="{ record }">
                          <p v-for="contact in record.contacts" :key="contact.id" class="text-truncate">
                            {{ contact.name }}
                          </p>
                        </template>
                        <template slot="email" slot-scope="{ record }">
                          <p v-for="contact in record.contacts" :key="contact.id" class="text-truncate">
                            {{ contact.email }}
                          </p>
                        </template>
                        <template slot="contact_group_id" slot-scope="{ record }">
                          <router-link
                            class="nav-link-detail"
                            :to="{ path: `/contact-group/${record.id}`}"
                          >
                            Edit
                          </router-link>
                        </template>
                      </PaginationTable>
                    </a-modal>
                    <a-col :span="8">
                      <a-form-item v-show="false" label=" " class="hidden-label">
                        <a-checkbox v-decorator="['isMonitorExtFile', { valuePropName: 'checked' }]" disabled>
                          Monitor External Files
                        </a-checkbox>
                      </a-form-item>
                    </a-col>
                    <a-col :span="24">
                      <a-form-item class="mb-0">
                        <a-checkbox :checked="isOpenAdvOptions" @change="isOpenAdvOptions = !isOpenAdvOptions">
                          Advanced Options
                        </a-checkbox>
                      </a-form-item>
                    </a-col>
                    <a-col v-show="isOpenAdvOptions" :span="24" v-if="featureAccess && featureAccess['tags']">
                      <a-form-item>
                        <template slot="label">
                          Tags
                          <a-tooltip placement="top">
                            <template slot="title">
                              <span class="fs-10">
                                Specify the tags that should be applied to the webpage.
                              </span>
                            </template>
                            <a-icon type="info-circle" theme="filled" />
                          </a-tooltip>
                        </template>
                        <div class="d-flex">
                          <a-select
                            class="flex-grow-1"
                            mode="multiple"
                            v-decorator="[
                              'tagIds',
                              {
                                rules: []
                              }
                            ]"
                            size="large"
                            placeholder="Select tags"
                          >
                            <a-select-option v-for="tag in availableTags" :key="tag.id" :value="tag.id">
                              {{ tag.name }}
                            </a-select-option>
                          </a-select>
                          <a-button class="ml-2" type="primary" icon="plus" @click="openAddTagModal">
                            Add
                          </a-button>
                        </div>
                      </a-form-item>
                    </a-col>
                    <a-col v-show="isOpenAdvOptions" :span="12">
                      <a-form-item extra="Separate different keywords by a comma (,). Keywords are case-insensitive.">
                        <template slot="label">
                          Blacklisted keyword(s)
                          <a-tooltip placement="top" :overlayStyle="{ 'max-width': 'max-content' }">
                            <template slot="title">
                              <span class="fs-10">
                                Specify what blacklisted keyword(s) that should not appear on your webpage.<br>
                                An alert will be sent if the blacklisted keywords are detected on the page.<br>
                                Examples: mysql/php error.
                              </span>
                            </template> 
                            <a-icon type="info-circle" theme="filled" />
                          </a-tooltip>
                        </template>
                        <a-checkbox :checked="isUsingGenericBlacklistKeywords" @change="toggleGenericBlacklistKeywords">
                          Enable recommended keyword dictionary
                        </a-checkbox>
                        <a-textarea v-decorator="['keyWordToExclude']" :rows="6" class="row-6 mb-0" @change="setGenericBlacklistKeywordsToggle" />
                      </a-form-item>
                    </a-col>

                    <a-col v-show="isOpenAdvOptions" :span="12">
                      <a-form-item extra="Separate different keywords by a comma (,). Keywords are case-insensitive.">
                        <template slot="label">
                          Whitelisted keyword(s)
                          <a-tooltip placement="top" :overlayStyle="{ 'max-width': 'max-content' }">
                            <template slot="title">
                              <span class="fs-10">
                                Specify the whitelisted keyword(s) that we should monitor on your webpage.<br>
                                An alert will be sent if the whitelisted keywords are missing from the page.<br>
                                Examples: company name, webpage title.
                              </span>
                            </template>
                            <a-icon type="info-circle" theme="filled" />
                          </a-tooltip>
                        </template>
                        <br>
                        <a-textarea v-decorator="['keyWordToInclude']" :rows="6" class="row-6 mb-0" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-tab-pane>
                <a-tab-pane v-if="featureAccess && featureAccess['content-integrity-engine']" :key="ActivatedTabKeys.ContentNIntegrity" :forceRender="true" tab="Content & Integrity Analytics">
                  <div class="sub-descriptions">
                    <span>
                      You can view your settings below. Please remember to save your updated settings.
                    </span>
                    <br>
                    <span>
                      If you exclude an individual element, such as a script or image, from monitoring while the URL is in continuous monitoring mode, rebaseline the URL for the changes to take effect.
                    </span>
                  </div>
                  <content-analytics @recommendedValuesChange="recommendedValuesChange" />
                </a-tab-pane>
                <a-tab-pane v-if="featureAccess && featureAccess['image-engine']" :key="ActivatedTabKeys.Image" tab="Image Analytics" :forceRender="true">
                  <div class="sub-descriptions">
                    <span>
                      A maximum of 4 regions can be selected. Selected regions are highlighted in red.
                    </span>
                  </div>
                  <ImageAnalytics ref="imageAnalyticsRef" @changeThreshold="onChangeThreshold" />
                </a-tab-pane>
                <a-tab-pane v-if="featureAccess && featureAccess['video-change-detector-engine']" :key="ActivatedTabKeys.VideoDefacementEngine" tab="Video Defacement Engine" :forceRender="true">
                  <div class="sub-descriptions">
                    <span>
                      Review extracted video thumbnails and choose which videos should be monitored.
                    </span>
                  </div>
                  <div class="mb-3">
                    <a-checkbox v-model="isEnableVideoChangeDetector">
                      Enable Video Change Detector
                    </a-checkbox>
                  </div>
                  <template v-if="videoDefacementItems.length">
                    <div class="video-defacement-grid">
                      <div
                        v-for="videoItem in videoDefacementItems"
                        :key="videoItem.id"
                        class="video-defacement-card"
                        :class="{ 'video-defacement-card--selected': videoItem.isMonitored }"
                        @click="onToggleVideoMonitoring(videoItem.id, !videoItem.isMonitored)"
                      >
                        <video
                          :src="videoItem.videoUrl"
                          :poster="videoItem.posterUrl || null"
                          preload="metadata"
                          muted
                          playsinline
                          class="video-defacement-card__thumbnail"
                        ></video>
                        <div class="video-defacement-card__content">
                          <div class="video-defacement-card__actions">
                            <a-checkbox
                              :checked="videoItem.isMonitored"
                              @click.stop
                              @change="onToggleVideoMonitoring(videoItem.id, $event.target.checked)"
                            >
                              {{ videoItem.videoUrl }}
                            </a-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <a-alert v-else type="info" show-icon message="No videos extracted from this URL yet." />
                </a-tab-pane>
                <a-tab-pane :key="ActivatedTabKeys.StaticMalwareScan" tab="Javascript Malware Detection" :forceRender="true">
                  <!-- <div class="sub-descriptions">
                    <span>
                      Scan Javascript files to detect potentially malicious scripts
                    </span>
                  </div> -->
                  <StaticMalwareScan ref="staticMalwareScanRef" @verify-webpage="saveAndVerifyWebpage" />
                </a-tab-pane>
                <a-tab-pane :key="ActivatedTabKeys.NLPEngine" tab="AI NLP Engine" :forceRender="true">
                  <a-tabs default-active-key="deeplearning-nlp">
                    <a-tab-pane key="deeplearning-nlp" tab="NLP Classifier">
                      <NLPDeepLearningEngine
                        ref="nlpDeepLearningEngineRef"
                        :nlpEngineConfiguration="webpage.nlp_engine_configuration"
                        :nlpNotificationConfig="webpage.nlp_notification_config"
                        :policies="webpage.policies"
                        @verify-webpage="saveAndVerifyWebpage"
                        @save-config="saveFormHelper"
                      />
                    </a-tab-pane>
                    <a-tab-pane v-if="featureAccess && featureAccess['keyword-sets-engine']" key="nlp-keywords" tab="NLP Keywords" :forceRender="true">
                      <NLPKeywords ref="nlpKeywordsRef" :selected-keyword-sets="webpage.keyword_set_configuration" />
                    </a-tab-pane>
                  </a-tabs>
                </a-tab-pane>
                <a-tab-pane :key="ActivatedTabKeys.PreviewHTML" tab="Preview HTML DOM">
                  <div class="sub-descriptions">
                    <span>
                      View the baseline HTML content captured during the baselining process.
                    </span>
                  </div>
                  <PreviewHtml v-if="activeTabKey === ActivatedTabKeys.PreviewHTML" :urlId="webpage.id" />
                </a-tab-pane>
                <a-tab-pane :key="ActivatedTabKeys.PreviewBaselineImage" tab="Preview Baseline Image">
                  <div class="sub-descriptions">
                    <span>
                      View the baseline screenshot captured during the baselining process.
                    </span>
                  </div>
                  <PreviewBaselineImage
                    v-if="activeTabKey === ActivatedTabKeys.PreviewBaselineImage"
                    :urlId="webpage.id"
                  />
                </a-tab-pane>
                <a-tab-pane
                  v-if="featureAccess && featureAccess['alert-triage']"
                  :key="ActivatedTabKeys.AiTriageRules"
                  tab="AiTriage Rules"
                  :forceRender="true"
                >
                  <div class="sub-descriptions">
                    <span>
                      Configure backend-defined triage items (Low / Medium / High), prompt versions and preview.
                    </span>
                  </div>
                  <AiTriageRulesWorkspace
                    v-if="activeTabKey === ActivatedTabKeys.AiTriageRules"
                    ref="aiTriageRules"
                    :url-id="webpage.id"
                    :storage-scope-key="promptRulesStorageScopeKey"
                    :storage-scope-is-domain="promptRulesScopeIsDomain"
                    :configurable-items="aiTriageConfigurableItems"
                    :server-ai-triage="webpage.ai_triage"
                    :saving-preferences="aiTriageSaving"
                    :saving-prompt="aiTriageSavingPrompt"
                    :preferences-section-enabled="isFqdnAiTriagePreferencesFeatureEnabled"
                    :prompt-section-enabled="isFqdnAiTriagePromptFeatureEnabled"
                    :advanced-prompt-ui-enabled="isFqdnAiTriagePromptFeatureEnabled"
                    @save-preferences="onAiTriageSavePreferences"
                    @save-prompt="onAiTriageSavePrompt"
                  />
                </a-tab-pane>
              </a-tabs>
            </div>
          </template>
        </transition-group>
      </div>
      <div class="a-footer">
        <a-button key="submit" size="large" type="primary" html-type="submit" class="slide-down-enter-active" :loading="isSaving">
          Save
        </a-button>
      </div>
    </a-form>
    <a-modal v-model="isShowProgressPerformingBaseline" :footer="null" :closable="false" :maskClosable="false" :keyboard="false" class="progress-modal">
      <a-form>
        <a-progress strokeLinecap="square" :percent="percentPerformingBaseline" status="active" />
        <p class="mb-0 text-center font-small">
          {{ baselineMessage }}
        </p>
        <p class="mb-0 text-center font-small">
          Waiting for baseline to complete
        </p>
        <a-alert showIcon type="warning" class="mt-1">
          <template slot="message">
            Performing intelligent baseline.
            <br>
            This will take about 2 - 3 minutes depending on the contents of the webpage
          </template>
        </a-alert>
      </a-form>
    </a-modal>

    <a-modal
      v-model="isShowProgressVerifyWebpage"
      style="top: 20px;"
      width="80vw"
      class="rebaseline-modal"
      title="Verification Results"
      cancelText="Close"
      :okButtonProps="{ style: { display: 'none' } }"
      :closable="false"
      :maskClosable="false"
      :bodyStyle="{
        padding: '16px 24px',
        overflowY: 'auto',
        height: 'auto',
        maxHeight: 'calc(80vh - 20px)',
      }"
    >
      <p v-if="!resultVerifyWebpage" class="mb-1 text-center loading-verify-text">
        <a-icon type="sync" spin :style="{ color: '#e74c3c' }" />
        Verifying
      </p>
      <template v-if="resultVerifyWebpage">
        <VerifyResult :result="resultVerifyWebpage" />
      </template>
    </a-modal>
    <a-modal
      v-model="isShowAddTagModal"
      title="Create Tag"
      :confirmLoading="isCreatingTag"
      :maskClosable="false"
      @ok="handleCreateTag"
      @cancel="closeAddTagModal"
    >
      <p class="mb-2">Create a new tag for this user.</p>
      <a-input
        v-model="newTagName"
        placeholder="Enter tag name"
        :disabled="isCreatingTag"
        @pressEnter="handleCreateTag"
      />
    </a-modal>
  </div>
</template>

<script>
import {
  flatMapErrMessagesValidateForm,
  debounceTimeExecute,
} from "@shared/helpers/utils";
import DataService from "@shared/services/data.service";
import WebpageService from "../services/webpage.service";
import ContentAnalytics from "./ContentAnalytics";
import ImageAnalytics from "./ImageAnalytics";
import StaticMalwareScan from "./StaticMalwareScan";
import NLPKeywords from "./NLPKeywords";
import NLPDeepLearningEngine from "./NLPDeepLearningEngine.vue";
import VerifyResult from "./VerifyResult";
import PreviewHtml from "./PreviewHtml.vue";
import PreviewBaselineImage from "./PreviewBaselineImage.vue";
import AiTriageRulesWorkspace from "./AiTriageRulesWorkspace.vue";
import { ActivatedTabKeys } from "../consts/Webpage.consts";
import { AI_TRIAGE_CONFIG_ITEMS_EXAMPLE } from "../consts/aiTriage.consts";
import { debounce } from "lodash";
  import NotificationService from '@modules/Notification/services/notification.service';
  import ContactGroupService from '@modules/ContactGroup/services/contact-group.service';
  import { ContactGroupColumns } from "../helper.js";
  import TagsService from '../../Tags/services/tags.service';

  export default {
    name: 'WebpageEdit',
    components: {
      ContentAnalytics,
      ImageAnalytics,
      StaticMalwareScan,
      NLPKeywords,
      VerifyResult,
      NLPDeepLearningEngine,
      PreviewHtml,
      PreviewBaselineImage,
      AiTriageRulesWorkspace,
    },
    data() {
      return {
        ActivatedTabKeys,
        planTypes: {},
        userAgents: [],
        pullingIntervals: [],
        downtimeAlerts: [],
        webpage: {
          id: +this.$route.params.id,
        },
        content: {},
        isOpenAdvOptions: false,
        isVerified: false,
        imageRegions: [],
        thresholdImageSimilarity: 0,
        recommendedValues: [],
        isShowProgressPerformingBaseline: false,
        percentPerformingBaseline: 0,
        isShowProgressVerifyWebpage: false,
        resultVerifyWebpage: null,
        isClosable: false,
        baselineMessage: 'Performing baseline 1 of 3',
        isLoading: true,
        getWebpageRequest$: null,
        activeTabKey: '',
        isUsingGenericBlacklistKeywords: false,
        genericBlacklistKeywords: [
          "hack", "hacker", "hacked", "hacking", "h4ck", "hackeado", "deface", "defacement", "d3f4c3", "vandalise", "Vandalism", "vandalize", "v4nd4lis3", "exploit", "exploited", "Black Hat", "Hacker Team", "Pwned", "Pawned", "Anonymous", "Xploit"
        ],
        isSaving: false,
        contactGroups: [],
        isContactGroupsLoaded: false,
        displayedContacts: [],
        isModalVisible: false,
        ContactGroupColumns,
        availableTags: [],
        isShowAddTagModal: false,
        newTagName: '',
        isCreatingTag: false,
        isEnableVideoChangeDetector: false,
        videoDefacementItems: [],
        aiTriageSaving: false,
        aiTriageSavingPrompt: false,
      };
    },
    computed: {
      featureAccess() {
        return (
          (this.$store.state.user &&
            this.$store.state.user.data &&
            this.$store.state.user.data.feature_access) ||
          {}
        );
      },
      isAiTriageRulesFeatureEnabled() {
        return Boolean(this.featureAccess && this.featureAccess['alert-triage']);
      },
      isFqdnAiTriagePromptFeatureEnabled() {
        return Boolean(this.featureAccess && this.featureAccess['fqdn-ai-triage-prompt']);
      },
      isFqdnAiTriagePreferencesFeatureEnabled() {
        return Boolean(this.featureAccess && this.featureAccess['fqdn-ai-triage-preferences']);
      },
      promptRulesStorageScopeKey() {
        const p = this.$route.params;
        const serverScope = this.webpage
          && this.webpage.ai_triage
          && typeof this.webpage.ai_triage.scope_key === 'string'
          ? this.webpage.ai_triage.scope_key.trim()
          : '';
        if (serverScope) {
          return serverScope;
        }
        const domainFromRoute =
          p.domainId != null && String(p.domainId) !== '' ? p.domainId : null;
        if (domainFromRoute != null) {
          return `domain-${domainFromRoute}`;
        }
        const w = this.webpage;
        if (!w || w.id == null) {
          return `url-${p.id != null ? p.id : this.$route.params.id}`;
        }
        const did =
          w.domain_id != null
            ? w.domain_id
            : w.subscribed_domain_id != null
              ? w.subscribed_domain_id
              : w.domain && w.domain.id != null
                ? w.domain.id
                : null;
        if (did != null && String(did) !== '') {
          return `domain-${did}`;
        }
        return `url-${w.id}`;
      },
      promptRulesScopeIsDomain() {
        const key = String(this.promptRulesStorageScopeKey || '');
        return key.indexOf('domain-') === 0 || key.indexOf('fqdn:') === 0;
      },
      /**
       * Dimensions to show (from API). Until backend sends `ai_triage_config_items`, example items are used for local dev.
       */
      aiTriageConfigurableItems() {
        const items = this.webpage && this.webpage.ai_triage_config_items;
        if (Array.isArray(items)) {
          return items;
        }
        return AI_TRIAGE_CONFIG_ITEMS_EXAMPLE;
      },
    },
    watch: {},
    beforeCreate() {
      this.editWebpageForm = this.$form.createForm(this, {
        name: 'edit-webpage-form',
        webPageUrl: '',
        webPagePort: '',
        webPageName: '',
        planType: '',
        userAgent: '',
        downTimeAlert: '',
        pollingInterval: '',
        policy: '',
        isContinuousMonitor: false,
        isMonitorExtFile: false,
        keyWordToInclude: '',
        keyWordToExclude: '',
      });
    },
    mounted() {
      this.downtimeAlerts = Array.from(Array(13).keys()).map(key => ({
        id: key + 2,
        name: `Notify after ${key + 2} failures`,
      }));
      this.getContactGroups(this.webpage.id);
      this.getDatas();
      if (location.hash) {
        const hashUrl = location.hash.replace('#', '').trim();
        if (hashUrl === 'LlmPromptRulesTab') {
          this.onTabChange(ActivatedTabKeys.AiTriageRules);
        } else if (Object.values(ActivatedTabKeys).includes(hashUrl)) {
          this.onTabChange(hashUrl);
        } else {
          this.onTabChange(ActivatedTabKeys.GeneralSettings);
        }
      } else {
        this.onTabChange(ActivatedTabKeys.GeneralSettings);
      }
    },
    beforeMount() {
      this.getWebpageRequest$ = this.$cancelRequest();
    },
    beforeDestroy() {
      this.getWebpageRequest$.cancel('Redirect to another page');
    },
    methods: {
      async onAiTriageSavePreferences(payload) {
        if (!payload || payload.urlId == null) {
          return;
        }
        this.aiTriageSaving = true;
        try {
          const aiTriage = await WebpageService.putAiTriagePreferences(payload.urlId, {
            itemLevels: payload.itemLevels,
          });
          this.$set(this.webpage, 'ai_triage', aiTriage);
          this.$nextTick(() => {
            const panel = this.$refs.aiTriageRules;
            if (panel && typeof panel.applyFromServer === 'function') {
              panel.lastAppliedAiTriageScopeKey = null;
              panel.applyFromServer(aiTriage);
            }
          });
          this.$showSuccessMessage('AiTriage preferences saved.');
        } catch (error) {
          this.$showMultiErrorMessage(this.normalizeAxiosError(error));
        } finally {
          this.aiTriageSaving = false;
        }
      },
      async onAiTriageSavePrompt(payload) {
        if (!payload || payload.urlId == null) {
          return;
        }
        this.aiTriageSavingPrompt = true;
        try {
          const aiTriage = await WebpageService.putAiTriagePrompt(payload.urlId, {
            draft_content: payload.draft_content,
          });
          this.$set(this.webpage, 'ai_triage', aiTriage);
          this.$nextTick(() => {
            const panel = this.$refs.aiTriageRules;
            if (panel && typeof panel.applyFromServer === 'function') {
              panel.lastAppliedAiTriageScopeKey = null;
              panel.applyFromServer(aiTriage);
            }
          });
          this.$showSuccessMessage('AiTriage prompt saved.');
        } catch (error) {
          this.$showMultiErrorMessage(this.normalizeAxiosError(error));
        } finally {
          this.aiTriageSavingPrompt = false;
        }
      },
      async onSubmit(e) {
        e.preventDefault();
        console.log("Waiting for form to save");
        await this.saveFormHelper();
        console.log("Form saved");
      },
      async getContactGroups(webpageId) {
        // filter notification settings based on the webpageId
        // get the contact group based on the contact group id
        try {
          const filteredSettings = await WebpageService.getNotificationConfigurations(this.webpage.id);

          if (filteredSettings.length > 0) {
            await Promise.all(filteredSettings.map(async (setting, index) => {
              const contactGroup = await ContactGroupService.get(setting.contact_group_id);
              contactGroup.index = index + 1;
              this.contactGroups.push(contactGroup);

              contactGroup.contacts.forEach((contact) => {
                if (this.displayedContacts.length < 5) {
                  this.displayedContacts.push(` ${contact.name}`);
                }
              })
            }));
          }

          this.isContactGroupsLoaded = true;
        } catch(err) {
          this.$showErrorMessage(err);
        }
      },
      showContactsModal() {
        this.isModalVisible = true;
      },
      handleContactsModalCancel() {
        this.isModalVisible = false;
      },
      handleContactsModalOk() {
        this.$router.push("/contact-group/list");
      },
      saveFormHelper() {
        return new Promise((resolve, reject) => {
          this.editWebpageForm.validateFields((err, values) => {
            if (!err) {
              const titleValue = this.recommendedValues.find(item => item.description === 'HTML Title');
            const lineNumValue = this.recommendedValues.find(item => item.description === '# of HTML Lines');
            const hrefValue = this.recommendedValues.find(item => item.description === 'Href Links');
            const imgValue = this.recommendedValues.find(item => item.description === 'Images');
            const scriptValue = this.recommendedValues.find(item => item.description === 'Javascripts');
            const divValue = this.recommendedValues.find(item => item.description === 'Divisions');
            const iframeValue = this.recommendedValues.find(item => item.description === 'Iframes');
            const formValue = this.recommendedValues.find(item => item.description === 'Forms');
            const linkValue = this.recommendedValues.find(item => item.description === 'Cascading Styles Sheets');
            const hashValue = this.recommendedValues.find(item => item.description === 'Full Page Signature');

            const customElements = this.recommendedValues.filter(item => item.isCustomElement);
            const customElementThresholds = customElements.map((item) => {
                return {
                    id: item.customElementCountId,
                    threshold: item.threshold,
                    enable: item.enable
                }
            });
            const customElementValues = customElements.map(item => {
               return {
                   id: item.customElementCountId,
                   count: item.baselineValue
               }
            });
            const customElementDetails = customElements.flatMap(item => item.detail);
            // console.log(customElementThresholds, customElementValues, customElementDetails);

            const imageAnalyticsData = this.$refs && this.$refs.imageAnalyticsRef && this.$refs.imageAnalyticsRef.$data;
            const staticMalwareScanData = this.$refs && this.$refs.staticMalwareScanRef && this.$refs.staticMalwareScanRef.$data;
            const nlpKeywordsData = this.$refs && this.$refs.nlpKeywordsRef && this.$refs.nlpKeywordsRef.$data;
            const nlpDeepLearningEngineData = this.$refs && this.$refs.nlpDeepLearningEngineRef && this.$refs.nlpDeepLearningEngineRef.$data;
            let nlpDeepLearningData = {};
            if (nlpDeepLearningEngineData.updated) {
              nlpDeepLearningData["distilbert"] = nlpDeepLearningEngineData.distilbert_model;
              nlpDeepLearningData["xgboost"] = nlpDeepLearningEngineData.xgboost_model;
            } else {
              nlpDeepLearningData = {};
            }
            const nlp_notification_configuration = {
              enabled: nlpDeepLearningEngineData.enable_nlp_deeplearning_engine,
              notification_policy: nlpDeepLearningEngineData.notification_policy,
            }
            const formatModelSaveEdit = {
              id: this.webpage && this.webpage.id,
              config_name: values.webPageName,
              plan_type: values.planType,
              polling_interval: values.pollingInterval,
              continuous_monitoring: values.isContinuousMonitor,
              warning_limit: Math.max(values.downTimeAlert, 2),
                tag_ids: values.tagIds || [],
              threshold: {
                enable_content_engine: this.recommendedValues.some(item => item.enable),
                enable_image_engine: imageAnalyticsData && imageAnalyticsData.isEnableImageAnalytics,
                enable_title: titleValue && titleValue.enable,
                threshold_line_num: (lineNumValue && lineNumValue.threshold) || 0,
                enable_line_num: lineNumValue && lineNumValue.enable,
                threshold_href: (hrefValue && hrefValue.threshold) || 0,
                enable_href: hrefValue && hrefValue.enable,
                threshold_img: (imgValue && imgValue.threshold) || 0,
                enable_img: imgValue && imgValue.enable,
                threshold_script: (scriptValue && scriptValue.threshold) || 0,
                enable_script: scriptValue && scriptValue.enable,
                threshold_div: (divValue && divValue.threshold) || 0,
                enable_div: divValue && divValue.enable,
                threshold_iframe: (iframeValue && iframeValue.threshold) || 0,
                enable_iframe: iframeValue && iframeValue.enable,
                threshold_form: (formValue && formValue.threshold) || 0,
                enable_form: formValue && formValue.enable,
                threshold_link: (linkValue && linkValue.threshold) || 0,
                enable_link: linkValue && linkValue.enable,
                image_similarity: (imageAnalyticsData && imageAnalyticsData.thresholdImageSimilarity) || (this.webpage.threshold && this.webpage.threshold.image_similarity),
                enable_hash: hashValue && hashValue.enable,
                enable_static_malware_scan: staticMalwareScanData && staticMalwareScanData.isEnableStaticMalwareScan,
                enable_video_change_detector: this.isEnableVideoChangeDetector,
              },
              sih_conf: {
                url_id: this.webpage && this.webpage.id,
                enable_sih: imgValue && !!imgValue.enable_sih,
                sih_threshold: imgValue && imgValue.sih_threshold,
              },
              custom_element_threshold: customElementThresholds,
              monitoring_configuration: {
                user_agent_id: values.userAgent,
                text_string_appear: this.isOpenAdvOptions ? values.keyWordToInclude : '',
                text_string_not_appear: this.isOpenAdvOptions ? values.keyWordToExclude : '',
              },
              current_baseline: {
                id: this.webpage.current_baseline && this.webpage.current_baseline.id,
                title: this.webpage.current_baseline && this.webpage.current_baseline.title,
                line_num: lineNumValue && lineNumValue.baselineValue,
                count_href: hrefValue && hrefValue.baselineValue,
                count_script: scriptValue && scriptValue.baselineValue,
                count_link: linkValue && linkValue.baselineValue,
                count_image: imgValue && imgValue.baselineValue,
                count_div: divValue && divValue.baselineValue,
                count_iframe: iframeValue && iframeValue.baselineValue,
                count_form: formValue && formValue.baselineValue,
                hash: this.webpage.current_baseline && this.webpage.current_baseline.hash,
                baseline_hrefs: ((hrefValue && hrefValue.detail) || []).map(baselineHrefItem => ({
                  id: baselineHrefItem.id,
                  selected: baselineHrefItem.selected,
                })),
                baseline_iframes: ((iframeValue && iframeValue.detail) || []).map(baselineIframeItem => ({
                  id: baselineIframeItem.id,
                  selected: baselineIframeItem.selected,
                })),
                baseline_forms: ((formValue && formValue.detail) || []).map(baselineFormItem => ({
                  id: baselineFormItem.id,
                  selected: baselineFormItem.selected,
                })),
                baseline_images: ((imgValue && imgValue.detail) || []).map(baselineImageItem => ({
                  id: baselineImageItem.id,
                  selected: baselineImageItem.selected,
                })),
                baseline_scripts: ((scriptValue && scriptValue.detail) || []).map(baselineScriptItem => ({
                  id: baselineScriptItem.id,
                  selected: baselineScriptItem.selected,
                })),
                baseline_stylesheets: ((linkValue && linkValue.detail) || []).map(baselineStylesheetItem => ({
                  id: baselineStylesheetItem.id,
                  selected: baselineStylesheetItem.selected,
                })),
                baseline_custom_elements: (customElementDetails || []).map((baselineCustomElementItem) => ({
                    id: baselineCustomElementItem.id,
                    selected: baselineCustomElementItem.selected,
                })),
                baseline_custom_element_counts: customElementValues,
                baseline_video_thumbnails: this.videoDefacementItems.map(item => ({
                  id: item.id,
                  selected: item.isMonitored,
                })),
              },
              image_regions: (this.imageRegions || []).map(imageRegion => ({
                coord_x: imageRegion.coord_x,
                coord_y: imageRegion.coord_y,
                coord_w: imageRegion.coord_w,
                coord_h: imageRegion.coord_h,
                })),
                keyword_set_configuration: (nlpKeywordsData && nlpKeywordsData.selectedKeywordSetsUpdated) || [],
              nlp_engine_configuration: nlpDeepLearningData,
              nlp_notification_config: nlp_notification_configuration,
              };

              this.isSaving = true;
              WebpageService.updateUrlConfig(+this.$route.params.id, formatModelSaveEdit).then(() => {
                this.$showSuccessMessage('Webpage settings saved');
                resolve("Saved");
              }).catch((error) => {
                this.$showMultiErrorMessage(error.messages);
                reject("Error when saving");
              }).finally(() => {
                this.isSaving = false;
              });
            }
            if (err) {
              debounceTimeExecute(flatMapErrMessagesValidateForm(err), this.$showErrorMessage);
              reject("Error when validating");
            }
          });
        });
      },
      setEditWebpageForm() {
        this.editWebpageForm.setFieldsValue({
          webPageUrl: this.webpage.url_name,
          webPagePort: this.webpage.monitoring_configuration.port_num,
          webPageName: this.webpage.config_name,
          planType: this.webpage.plan_type,
          userAgent: this.webpage.monitoring_configuration.user_agent_id,
          downTimeAlert: this.webpage.warning_limit && this.webpage.warning_limit > 2 ? this.webpage.warning_limit : 2,
          pollingInterval: this.webpage.polling_interval,
          isContinuousMonitor: this.webpage.continuous_monitoring,
          isMonitorExtFile: this.webpage.monitor_ext,
          keyWordToInclude: this.webpage.monitoring_configuration.text_string_appear,
          keyWordToExclude: this.webpage.monitoring_configuration.text_string_not_appear,
          policy: (this.webpage.policies || []).map(itemPolicy => `${itemPolicy.name} - ${itemPolicy.description}`).join(', '),
          tagIds: (Array.isArray(this.webpage.tags) ? this.webpage.tags.map(t => t.id || t.tagID).filter(Boolean) : []),
        });
        this.isOpenAdvOptions = !!String(this.webpage.monitoring_configuration.text_string_appear).trim() || !!String(this.webpage.monitoring_configuration.text_string_not_appear).trim() || (Array.isArray(this.webpage.tags) && this.webpage.tags.length > 0);
        this.isVerified = !!this.webpage && !!this.webpage.last_verified && this.webpage.last_verified.result === 'OK';
        this.setGenericBlacklistKeywordsToggle();
      },
      async getDatas() {
        try {
          const [webpage, userAgents, enumsData, userData, tagsData] = await Promise.all([WebpageService.get(this.webpage.id), DataService.getUserAgents(), DataService.getEnums(), DataService.getUsers(), TagsService.getList((this.$store.state.user.data || {}).id)]);
          this.webpage = webpage;
          this.content = webpage;
          this.webpage.monitor_ext = Boolean(this.webpage.monitor_ext);
          this.imageRegions = webpage.image_regions || [];
          this.thresholdImageSimilarity = (webpage.threshold && webpage.threshold.image_similarity) || 0;
          this.isEnableVideoChangeDetector = !!(webpage.threshold && webpage.threshold.enable_video_change_detector);

          const videoData = await WebpageService.getVideoThumbnails(webpage.id);
          this.videoDefacementItems = ((videoData && videoData.thumbnails) || []).map(item => ({
            id: item.id,
            videoUrl: item.video_url,
            posterUrl: item.data || '',
            platform: item.platform,
            isMonitored: !!item.selected,
          }));

          this.userAgents = userAgents;
          this.planTypes = userData.plan_usage || {};
          this.pullingIntervals = (enumsData && enumsData.url && enumsData.url.polling_interval[this.webpage.plan_type]) || {};
          this.availableTags = tagsData || [];

          this.setEditWebpageForm();
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        } finally {
          if (this.isLoading) {
            this.isLoading = false;
          }
        }
      },
      recommendedValuesChange(recommendedValues) {
        this.recommendedValues = recommendedValues;
      },
      openRenderingConfig() {
        const urlId = this.webpage && this.webpage.id;
        if (!urlId) {
          return;
        }
        const route = this.$router.resolve({
          path: '/policy/rendering',
          query: { tab: 'url', url_id: String(urlId) },
        });
        window.open(route.href, '_blank');
      },
      rebaselineWebpage() {
        this.$confirm({
          title: `You will be redirected to another page after the re-baseline completes.`,
          content: 'Please save your current configurations before proceeding.',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: async () => {
            this.isShowProgressPerformingBaseline = true;
            const performaneReBaselineResponse = await WebpageService.reBaselineWebpage(this.webpage.id);
            const { job_id } = performaneReBaselineResponse;
            const recursionPerformingBaselineRequest = async () => {
              try {
                const verifyResponse = await DataService.fetchStatusJob(job_id);
                const { status, result } = verifyResponse;
                if (status === 'Completed') {
                  this.isShowProgressPerformingBaseline = false;
                  this.$showSuccessMessage('The baseline of your webpage is successful!');
                  this.$router.push(`/webpages/baseline-result/${this.webpage.id}`);
                } else {
                  this.baselineMessage = result ? JSON.parse(result).message : this.baselineMessage;
                  const percentPerforming = result ? Math.min(JSON.parse(result).start_progress, 100) : 0;
                  this.percentPerformingBaseline = +percentPerforming.toFixed();
                  setTimeout(() => {
                    recursionPerformingBaselineRequest();
                  }, 3000);
                }
              } catch {
                this.isShowProgressPerformingBaseline = false;
                this.$showErrorMessage('The baseline of your webpage is error.');
              }
            };
            recursionPerformingBaselineRequest();
          },
        });
      },
      async manualVerifyWebpage(event) {
        event.stopPropagation();
        await this.manualVerifyWebpageHelper();
      },
      async manualVerifyWebpageHelper() {
        this.resultVerifyWebpage = null;
        this.isClosable = false;
        this.resultVerifyWebpage = null;
        this.isShowProgressVerifyWebpage = true;
        const { job_id } = await WebpageService.manualVerifyWebpage(this.webpage.id);
        const recursionVerifyChecking = async () => {
          try {
            const verifyResponse = await DataService.fetchStatusJob(job_id);
            const { status, structured_result } = verifyResponse;
            if (status === 'Completed') {
              this.resultVerifyWebpage = structured_result;
              this.isClosable = true;
            } else {
              setTimeout(() => {
                recursionVerifyChecking();
              }, 5000);
            }
          } catch {
            this.resultVerifyWebpage = 'Verification failed. Please try again later!';
            this.isClosable = true;
          }
        };
        recursionVerifyChecking();
      },
      async saveAndVerifyWebpage() {
        try {
          await this.saveFormHelper();
          await this.manualVerifyWebpageHelper();
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        }
      },
      onChangeThreshold(thresholdImageSimilarity) {
        if (this.webpage && this.webpage.threshold) {
          this.webpage.threshold['image_similarity'] = thresholdImageSimilarity;
        }
      },
      onTabChange(currentActivatedTabKey) {
        if (
          currentActivatedTabKey === ActivatedTabKeys.AiTriageRules &&
          !this.isAiTriageRulesFeatureEnabled
        ) {
          currentActivatedTabKey = ActivatedTabKeys.GeneralSettings;
        }
        this.activeTabKey = currentActivatedTabKey;
        history.pushState({}, null, this.$route.path + '#' + encodeURIComponent(currentActivatedTabKey));
      },
      onToggleVideoMonitoring(videoId, isMonitored) {
        this.videoDefacementItems = this.videoDefacementItems.map(videoItem => (
          videoItem.id === videoId
            ? { ...videoItem, isMonitored }
            : videoItem
        ));
      },
      toggleGenericBlacklistKeywords() {
        if (this.isUsingGenericBlacklistKeywords) {
          this.removeGenericBlacklistKeywords();
        } else {
          this.addGenericBlacklistKeywords();
        }
      },
      setGenericBlacklistKeywordsToggle: debounce(function(event) {

        this.$nextTick(() => this.$nextTick(() => {

          let currentWords = this.editWebpageForm.getFieldValue('keyWordToExclude');
          if (currentWords === null) {
            currentWords = '';
          }
          currentWords = currentWords.split(',');
          currentWords = currentWords.map((a) => a.trim());

          let hasAllWords = true;

          const newWordsToAdd = this.genericBlacklistKeywords;
          // console.log(newWordsToAdd);
          for (let i = 0; i < newWordsToAdd.length; i++) {
            let alreadyHasWord = false;
            for (let j = 0; j < currentWords.length; j++) {
              if (newWordsToAdd[i].trim().toLowerCase() == currentWords[j].trim().toLowerCase()) {
                alreadyHasWord = true;
                break;
              }
            }
            if (!alreadyHasWord) {
              hasAllWords = false;
            }
          }

          if (hasAllWords) {
            this.isUsingGenericBlacklistKeywords = true;
          } else {
            this.isUsingGenericBlacklistKeywords = false;
          }

        }));
      }, 500, {leading: true}),
      addGenericBlacklistKeywords() {
        let currentWords = this.editWebpageForm.getFieldValue('keyWordToExclude');
        if (currentWords === null) {
          currentWords = '';
        }
        currentWords = currentWords.split(',');
        currentWords = currentWords.map((a) => a.trim());

        let newWords = currentWords;

        const newWordsToAdd = this.genericBlacklistKeywords;
        // console.log(newWordsToAdd);
        for (let i = 0; i < newWordsToAdd.length; i++) {
          let alreadyHasWord = false;
          for (let j = 0; j < currentWords.length; j++) {
            if (newWordsToAdd[i].trim().toLowerCase() == currentWords[j].trim().toLowerCase()) {
              alreadyHasWord = true;
              break;
            }
          }
          if (!alreadyHasWord) {
            newWords.push(newWordsToAdd[i])
          }
        }

        newWords = newWords.filter((a) => a.trim());

        this.editWebpageForm.setFieldsValue({
          'keyWordToExclude': newWords.join(", ")
        });

        this.setGenericBlacklistKeywordsToggle();
      },
      openAddTagModal() {
        this.newTagName = '';
        this.isShowAddTagModal = true;
      },
      closeAddTagModal() {
        this.isShowAddTagModal = false;
        this.newTagName = '';
      },
      async handleCreateTag() {
        const tagName = (this.newTagName || '').trim();
        if (!tagName) {
          this.$showErrorMessage('Please enter a tag name.');
          return;
        }
        if (this.availableTags.some(tag => tag.name === tagName)) {
          this.$showErrorMessage('Tag already exists.');
          return;
        }
        this.isCreatingTag = true;
        try {
          await TagsService.create({ tagName });
          const currentTagIds = this.editWebpageForm.getFieldValue('tagIds') || [];
          this.$showSuccessMessage(`Tag '${tagName}' created successfully.`);
          this.isShowAddTagModal = false;
          const tagsData = await TagsService.getList((this.$store.state.user.data || {}).id);
          this.availableTags = tagsData || [];
          const newTag = this.availableTags.find(t => t.name === tagName);
          if (newTag && !currentTagIds.includes(newTag.id)) {
            this.editWebpageForm.setFieldsValue({ tagIds: [...currentTagIds, newTag.id] });
          }
        } catch (err) {
          this.$showErrorMessage('Failed to create tag.');
        } finally {
          this.isCreatingTag = false;
          this.newTagName = '';
        }
      },
      removeGenericBlacklistKeywords() {
        let currentWords = this.editWebpageForm.getFieldValue('keyWordToExclude');
        if (currentWords === null) {
          currentWords = '';
        }
        currentWords = currentWords.split(',');
        currentWords = currentWords.map((a) => a.trim());

        let newWords = currentWords.filter((currentWord) => {
          const newWordsToAdd = this.genericBlacklistKeywords;
          for (let i = 0; i < newWordsToAdd.length; i++) {
            if (newWordsToAdd[i].trim().toLowerCase() == currentWord.trim().toLowerCase()) {
              return false;
            }
          }
          return true;
        });

        newWords = newWords.filter((a) => a.trim());

        this.editWebpageForm.setFieldsValue({
          'keyWordToExclude': newWords.join(", ")
        });

        this.setGenericBlacklistKeywordsToggle();
      }
    },
  };
</script>

<style lang="scss" scoped>
  .edit-webpage {
    height: 100%;
    .edit-form {
      height: 100%;
    }
  }
  .a-body {
    .info {
      background: #f7f7f7;
      overflow: hidden;
      padding: 20px;
      border-radius: 4px;
    }
    .tabs {
      margin-top: 10px;
      .ant-tabs-nav .ant-tabs-tab {
        padding-left: 0px !important;
      }
    }
    .sub-descriptions {
      background: #f7f7f7;
      overflow: hidden;
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 20px;
    }
    .video-defacement-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      grid-gap: 16px;
    }
    .video-defacement-card {
      border: 1px solid #f0f0f0;
      border-radius: 4px;
      overflow: hidden;
      background: #ffffff;
      cursor: pointer;
      transition: border-color 0.2s, box-shadow 0.2s;
      &:hover {
        border-color: #04b0ed;
      }
      &--selected {
        border-color: #04b0ed;
        box-shadow: 0 0 0 2px rgba(4, 176, 237, 0.2);
      }
    }
    .video-defacement-card__thumbnail {
      width: 100%;
      height: 180px;
      object-fit: cover;
      background: #f7f7f7;
    }
    .video-defacement-card__content {
      padding: 12px;
    }
    .video-defacement-card__actions {
      margin-bottom: 8px;
    }
    .video-defacement-card__url {
      display: block;
      margin-bottom: 8px;
      word-break: break-all;
    }
    .video-defacement-card__source {
      margin-bottom: 0;
      font-size: 12px;
      color: #8c8c8c;
      word-break: break-all;
    }
  }
  .a-header--button {
    display: flex;
    align-items: flex-end;
    padding: 6px 20px;
    border-radius: 4px;
    font-size: 11px;
    line-height: 16px;
    &.verified-btn {
      cursor: default;
      pointer-events: none;
    }
    &.invalid-btn {
      border: 1px solid #cecece;
      background-color: #dedede;
      color: #858688;
    }
    &.success-btn {
      background-color: #04b0ed;
      color: #ffffff;
    }
  }
  ::v-deep {
    .hidden-label.ant-row.ant-form-item .ant-form-item-label {
      opacity: 0;
    }
  }
  .loading-verify-text {
    font-size: 1rem;
  }
</style>
